$(document).ready(() => {
    console.log('ici');
    $('form').on('click', '.btn-select-workshop', function(){
        console.log($(this).data('value'));
        console.log($(this).data('select'));
        console.log($(this).data('class'));
        // On remplis l'input
        let input = document.getElementsByName($(this).data('select'))[0];
        input.value = $(this).data('value');
        //On enlève la classe select sur les autres éléments de cette session précise
        $($(this).data('class')).removeClass('selected');
        //On rajoute la classe pour dire qu'il est sélectionné
        $(this).addClass('selected');
    });
});
